import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Homepage from './pages/Homepage';
import Login from './pages/Login';
import Contact from './pages/Contact';
import About from './pages/About';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import Portfolio from './pages/Portfolio';
import Unauthorized from './pages/Unauthorized';
import NotFound from './pages/NotFound';
import InvestmentPlans from './pages/InvestmentPlans';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';

// Legal Pages
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Disclosures from './pages/legal/Disclosures';
import Regulatory from './pages/legal/Regulatory';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Router>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            {/* Public Routes - No authentication required */}
            <Route path="/" element={<Homepage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/investment-plans" element={<InvestmentPlans />} />

            {/* Protected Routes - Require authentication */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              }
            />

            {/* Legal Routes */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclosures" element={<Disclosures />} />
            <Route path="/regulatory" element={<Regulatory />} />

            {/* Admin Routes */}
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />

            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
